export const EMPTY_ENTRY_MANIPULATION_DEFINITION = {
    targetFolderId: null,
    rightsByTarget: true
};